const alt = require('components/alt');

class PaymentMethodSelectionActions {
  updateShopCurrency(currency) {
    return currency;
  }
  initializeShopCurrency(currency) {
    return currency;
  }
}

const actions = alt.createActions(PaymentMethodSelectionActions);

class PaymentMethodSelectionStore {
  constructor() {
    this.bindListeners({
      updateShopCurrency: actions.UPDATE_SHOP_CURRENCY,
      initializeShopCurrency: actions.INITIALIZE_SHOP_CURRENCY,
    });
  }

  updateShopCurrency(currency) {
    this.shopCurrency = currency;
  }

  initializeShopCurrency(currency) {
    this.shopCurrency = currency;
    this.originalShopCurrency = currency;
  }
}

const store = alt.createStore(PaymentMethodSelectionStore, 'PaymentMethodSelectionStore');

module.exports = { actions, store };



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/shop_policies/payment_method_selection_module.js